export default {
  pos: 'POS',
  msi: 'MSI',
  ecommerce: 'Ecommerce',
  import: 'Import',
  in_store: 'In Store'
}
